<template>
  <client-only>
    <sup v-if="!hasReference">
      <a
        :id="`p-ref-${referenceId}`"
        :class="`${elementRefExists ? '' : '--no-target'}`"
        @click="scrollToElement(`ref-${referenceId}`, 130)"
      >
        {{ referenceText }}
      </a>
      {{ additionalText }}
    </sup>
    <sup v-else>
      <a
        :id="`ref-${referenceId}`"
        :class="`${elementPRefExists ? '' : '--no-target'}`"
        @click="scrollToElement(`p-ref-${referenceId}`, 130)"
      >
        {{ referenceText }}
      </a>
      {{ additionalText }}
    </sup>
  </client-only>
</template>
<script lang="ts" setup>
const { scrollToElement, targetExists } = useSmoothScroll()
const props = defineProps<{
  text: string
}>()

const pageStore = usePageStore()
const { referenceId, referenceText, additionalText } = useSuperscriptParser(props.text)

let hasReference = false

if (import.meta.client) {
  const reference = pageStore.getSuperscriptReference(referenceText)
  hasReference = !!reference

  if (!hasReference) {
    pageStore.addSuperscriptReference(referenceText)
  }
}

const elementRefExists = ref(false)
const elementPRefExists = ref(false)

useNuxtApp().hook('page:finish', () => {
  elementRefExists.value = targetExists('ref-' + referenceId)
  elementPRefExists.value = targetExists('p-ref-' + referenceId)
})
</script>
<style scoped>
sup {
  a.--no-target {
    color: var(--theme-black) !important;
    text-decoration: none !important;
  }

  a:not(.--no-target) {
    cursor: pointer;
    color: var(--theme-color) !important;
    text-decoration: underline !important;
  }
}
</style>
